import React, { useContext, useEffect, useState } from 'react'
import fetchHook from '../../hooks/fetchMSSQL-hook'
import { NavigationContext } from '../../context/navigation-context'
import langContext, { LangContext } from '../../context/lang-context'
import formHook from '../../hooks/form-hook'
import NoResults from '../../components/NoResults/NoResults'
import WarehouseForm from '../../components/Modals/WarehouseForm'
import { NotificationManager } from 'react-notifications'
import ReportButton from '../../components/Buttons/ReportButton'
import SearchFilter from "../../components/Filter/SearchFilter"


export default function Warehouses() {
    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(null);
    const [warehouses, setWarehouses] = useState([]);
    const [sortBy, setSortBy] = useState([])
    const {fetchMssqlApi} = fetchHook()
    const { setHeaderData } = useContext(NavigationContext)
    const {form, openForm, closeForm} = formHook()
    const {TRL_Pack} = useContext(LangContext)
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    const reportList = [
        { reportId: 71, reportColor: 'dark' }
    ].filter(Boolean);

    const defaultFilter = {
        page: 1,
        rowsPerPage: 100,
        isActive: "true",
        sortBy: "none",
    };

    const [filter, setFilter] = useState(defaultFilter);
        const [settingsFilter, setSettingsFilter] = useState({
        saveFilters: true,
        autoLoading: true,
        additionalFilter: true,
        flatView: false,
        rowsPerPage: 50,
    });

    const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

    const sortDefaults = {
        Name: "ASC",
        IsActive: "DESC",
    };

    const getSortState = () => {
        const [field, dir] = String(filter.sortBy || "").split("|");
        return { field, dir: (dir || "").toUpperCase() };
    };

    const sortState = getSortState();

    const arrow = (field) => {
        if (sortState.field !== field) return "";
        return sortState.dir === "ASC" ? " ▲" : " ▼";
    };

    const getWarehouses = (f = filter) => {
        const sortBy = typeof f === "object" ? f?.sortBy : null;

        let url = `warehouses`;
        if (sortBy && sortBy !== "none") {
            url += `?sortBy=${encodeURIComponent(sortBy)}`;
        }

        fetchMssqlApi(url, {}, res => {
            setWarehouses(res || [])
        })
    }

    const handleHeaderSort = (field) => {
        const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
        const curDir = (curDirRaw || "").toUpperCase();
        let nextDir;
        if (curField === field) {
            nextDir = curDir === "ASC" ? "DESC" : "ASC";
        } else {
            nextDir = sortDefaults[field] || "ASC";
        }
        setFilter({...filter, sortBy: `${field}|${nextDir}`});
    };

    const handleSubmit = evt => {
        evt.preventDefault();
        const {name} = evt.target.elements

        const isAvaiable = warehouses.filter(warehouse => warehouse.WarehouseId !== form).map(warehouse => warehouse.Name).indexOf(name.value) === -1
        if (!isAvaiable) {
            NotificationManager.error("Taka nazwa już istnieje")
            name.value = ""
            return
        }

        const currentWarehouse =
            form !== "new"
                ? warehouses.find((warehouse) => Number(warehouse.WarehouseId) === Number(form))
                : null;

        const currentIsActive =
            currentWarehouse?.IsActive === true ||
            currentWarehouse?.IsActive === 1 ||
            currentWarehouse?.IsActive === "1" ||
            currentWarehouse?.IsActive === "true";

        const isActivityButton = evt.nativeEvent?.submitter?.name === "isActive";

        const nextIsActive =
            form === "new"
                ? 1
                : isActivityButton
                    ? (currentIsActive ? 0 : 1)
                    : (currentIsActive ? 1 : 0);

        const payload = {
            Name: name.value,
            IsActive: nextIsActive
        }

        if (form === "new") {
            fetchMssqlApi('warehouse', {method: "POST", data: payload}, () => {
                getWarehouses(filter)
                closeForm()
            })
        } else {
            fetchMssqlApi(`warehouse/${form}`, {method: "PUT", data: payload}, () => {
                getWarehouses(filter)
                closeForm()
            })
        }
    }

    useEffect(() => {
        setHeaderData({text: "Magazyny"})
    }, [])

    return (
        <div>
            <SearchFilter
                filterName="warehouses"
                defaultFilter={defaultFilter}
                reportList={reportList}
                onFilterChange={(f) => setFilter(f)}
                onSettingsChange={(s) => setSettingsFilter(s)}
                sortBy={filter.sortBy}
                search={getWarehouses}
                loading={false}
                totalCount={warehouses.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
                dataList={warehouses}
                forNow
            />
            {warehouses.length ? (
                <div className='card'>
                <div className='card-header'>
                <button
                    className="d-block btn text-nowrap btn-outline-secondary text-decoration-none ml-auto my-2 mr-1"
                    onClick={openForm()}
                >
                    <i className="fas fa-plus"/>
                    {TRL_Pack.locations.addProductButton}
                </button>
            </div>

            <div
            className="overflow-auto custom-scroll"
            style={{
                maxHeight: `${windowHeight - 224}px`,
                overflowY: "auto",
                }}
            >

                <table className='table table-striped border' style={{width: "100%"}}>
                    <thead>
                        <tr className='text-center headers-color'>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Name")}
                            >
                                Magazyn{arrow("Name")}
                            </th>
                            <th
                                style={{ textAlign: "center", cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("IsActive")}
                            >
                                Aktywny{arrow("IsActive")}
                            </th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr/>
                        <tr/>
                    </thead>
                    <tbody>
                    {warehouses.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).map((warehouse, idx) => (
                            <tr className='text-center' key={idx}>
                                <td>
                                    {warehouse.Name}
                                </td>
                                <td className="p-1 text-center text-primary" style={{minWidth: "150px"}}><i className={warehouse.IsActive ? "fas fa-check-square" : "far fa-square"}/></td>
                                <td>
                                <ReportButton
                                    reportId={71}
                                    body={{
                                        warehouseId: warehouse.WarehouseId
                                    }}
                                    btnColor='dark'
                                />
                                </td>
                                <td className='d-flex justify-content-end mb-2 mt-2 border-0'>
                                    <button className="btn btn-outline-primary btn-sm "
                                            onClick={openForm(warehouse.WarehouseId)}
                                            >
                                        Edytuj
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </div>
            ) : (
                <NoResults buttonText={TRL_Pack.locations.addProduct} onClick={openForm()} />
            )}

            {form && (
                <WarehouseForm
                    handleClose={closeForm}
                    data={warehouses.find(warehouse => warehouse.WarehouseId === form)}
                    handleSubmit={handleSubmit}/>
            )}
        </div>
    )
}